/**
Save and restore a JSON object to and from local storage.
*/
export default {
  store: function store(key, obj) {
    try {
      localStorage.setItem(key, JSON.stringify(obj));
      return true;
    } catch (e) {
      return false;
    }
  },
  restore: function restore(key) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var obj = JSON.parse(localStorage.getItem(key));
    Object.assign(target, obj);
    return target;
  },
  clear: function clear(key) {
    localStorage.removeItem(key);
  }
};